import { render, staticRenderFns } from "./SkillsTable.vue?vue&type=template&id=b6b717c4&"
import script from "./SkillsTable.vue?vue&type=script&lang=js&"
export * from "./SkillsTable.vue?vue&type=script&lang=js&"
import style0 from "./SkillsTable.vue?vue&type=style&index=0&id=b6b717c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports